import { render } from "./ChatInputContainer.vue?vue&type=template&id=9d8f8d3c&scoped=true&lang=pug"
import script from "./ChatInputContainer.vue?vue&type=script&lang=js"
export * from "./ChatInputContainer.vue?vue&type=script&lang=js"

import "./ChatInputContainer.vue?vue&type=style&index=0&id=9d8f8d3c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d8f8d3c"]])

export default __exports__